import React, { Suspense } from 'react';

export const PublicTrialComponent = React.lazy(() => import('./PublicTrial'));

export const PublicTrial = () => (
  <Suspense fallback={null}>
    <PublicTrialComponent />
  </Suspense>
);
